<template>
  <!-- 优惠券列表 -->
  <div class="couponListBox">
    <Header style="position:relative" />
    <!-- 优惠券 -->
    <h3>Cupón</h3>
    <!-- 优惠券tab -->
    <div class="tabBox">
      <p
        style="margin-right: 0.91rem;"
        :class="[activeName == '1' ? 'active' : '']"
        @click="changeTab('1')"
      >
        En vigor
      </p>
      <p @click="changeTab('2')" :class="[activeName == '2' ? 'active' : '']">
        Caducado
      </p>
    </div>

    <ul v-if="couponList.length">
      <li v-for="item in couponList">
        <!-- 左侧金额/天数/折扣文案展示 -->
        <div
          class="leftTitle"
          :style="{
            color: couponColor[item.coupon_type],
            background: couponBgcColor[item.coupon_type],
          }"
        >
          <div style="display: flex;align-items: baseline;">
            <span v-show="item.coupon_type == 1">-</span>
            {{ item.distribute_amount }}
            <span style="font-size: 0.3rem;margin-left: 0.03rem;">
              {{ couponAmountText[item.coupon_type] }}
            </span>
          </div>
        </div>
        <!-- 右侧详情文案/时间展示 -->
        <div class="rightContent">
          <h5>{{ couponName[item.coupon_type] }}</h5>
          <h3>{{ couponDesc[item.coupon_type] }}</h3>
          <p>
            Vencimiento: {{ $setMoment(item.effective_date, 1) }} -
            {{ $setMoment(item.expire_date, 1) }}
          </p>
        </div>
        <!-- 2.冻结 3.已使用 4.无效/过期 -->
        <img
          src="../../assets/images/invalid.png"
          alt=""
          v-show="item.status == 2"
        />
        <img
          src="../../assets/images/used.png"
          alt=""
          v-show="item.status == 3"
        />
        <img
          src="../../assets/images/vencido.png"
          alt=""
          v-show="item.status == 4"
        />
      </li>
    </ul>

    <ul v-else>
      <div>
        <img src="../../assets/images/couponEmpty.png" alt="" />
        <p>Aún no hay cupones</p>
      </div>
    </ul>

    <van-overlay :show="loading">
      <div class="loadingIcon">
        <i class="el-icon-loading"></i>
        <p>
          loading...
        </p>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Header from "../../components/webComponents/header.vue";
import { getCouponList } from "../../utils/api/h5page";
export default {
  name: "",
  components: {
    Header,
  },
  props: {},
  data() {
    return {
      activeName: "1",
      loading: false,
      couponList: [],
      couponBgcColor: {
        1: "#FFEFEF", // 减免券背景颜色
        4: "#E4EFFF", // 提额券背景颜色
        5: "#E6FFF2", // 延期券背景颜色
        6: "#FFF1E6", // 折扣券背景颜色
      },
      couponColor: {
        1: "#D23D34", // 减免券字体颜色
        4: "#4244B7", // 提额券字体颜色
        5: "#2AAC76", // 延期券字体颜色
        6: "#CB844B", // 折扣券字体颜色
      },
      couponAmountText: {
        1: "", // 减免
        4: "", // 提额
        5: "días", // 延期券
        6: "%", // 折扣券
      },
      couponDesc: {
        1: "Hacer que reduzca la cantidad del préstamo a pagar", // 减免券
        4: "Hacer que obtenga más préstamos", // 提额券
        5: "Permitirle extender el número de días del préstamo", // 延期券
        6: "Puede reducir los intereses de su pedido según el descuento del cupón de descuento",
      },
      couponName: {
        1: "Cupón para reducir el pago", // 减免券
        4: "Cupón de aumento de límite", // 提额券
        5: "Cupón de extensión de plazo", // 延期券
        6: "Cupón de descuento", // 折扣券
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getCouponListData();
  },
  methods: {
    // 获取优惠券列表
    getCouponListData() {
      this.openLoading();
      getCouponList({
        offset: 0,
        ui_version: "231109",
        list_type: this.activeName,
        app_version_code: "10",
      }).then(({ data }) => {
        this.couponList = data.data.data;
        this.closeLoading();
      });
    },

    // 点击切换优惠券列表
    changeTab(row) {
      this.activeName = row;
      this.getCouponListData();
    },

    openLoading() {
      this.loading = true;
    },

    closeLoading() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.couponListBox {
  height: 100%;
  background: #f5f5f5;
  & > h3 {
    width: 12rem;
    margin: 0.61rem auto 0.36rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
  }
  .tabBox {
    width: 12rem;
    margin: 0 auto 0.3rem;
    display: flex;
    p {
      cursor: pointer;
      padding: 0.1rem;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.26rem;
      color: #666666;
    }
    .active {
      position: relative;
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 0.26rem;
      color: #333333;
      //   border-bottom: 0.04rem solid #c90000;
      &::after {
        content: "";
        width: 0.8rem;
        height: 0.04rem;
        background: #c90000;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  ul {
    display: flex;
    position: relative;
    justify-content: space-between;
    width: 12rem;
    margin: 0 auto;
    min-height: 3.5rem;
    max-height: 7.25rem;
    overflow-y: auto;
    flex-wrap: wrap;
    li {
      position: relative;
      display: flex;
      width: 5.86rem;
      height: 1.4rem;
      background: #ffffff;
      border-radius: 0.16rem;
      margin-bottom: 0.2rem;
      border: 0.01rem solid #d0d0d0;
      margin-right: 0.2rem;
      &:nth-child(2n) {
        margin-right: 0;
      }
      .leftTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.4rem;
        height: 100%;
        background: #e4efff;
        border-radius: 0.16rem;
        border: 0.02rem solid #ffffff;
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 0.36rem;
        line-height: 0.54rem;
      }

      .rightContent {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 0.15rem;
        h5 {
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 0.17rem;
          color: #333333;
        }
        h3 {
          width: 3.94rem;
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 0.17rem;
          color: #333333;
          margin: 0.03rem 0;
          line-height: 0.2rem;
        }
        p {
          font-family: Roboto, Roboto;
          font-weight: 400;
          font-size: 0.16rem;
          color: #999999;
        }
      }

      img {
        position: absolute;
        width: 0.28rem;
        height: 0.28rem;
        right: 0.2rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    & > div {
      position: absolute;
      left: 50%;
      top: 0.5rem;
      transform: translateX(-50%);
      text-align: center;
      img {
        width: 2.1rem;
        height: 2rem;
      }
      p {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.26rem;
        color: #666666;
        line-height: 0.38rem;
      }
    }
  }
}

.loadingIcon {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  font-size: 0.35rem;
  color: #409eff;
  i {
    font-size: 0.65rem;
    margin-bottom: 0.2rem;
  }
}

.van-overlay {
  z-index: 9999;
}
</style>
